import OfficerEdit from './OfficerEdit.container';

export default OfficerEdit;
